// extracted by mini-css-extract-plugin
export default {"help":"Help_help__jQjBu","link":"Help_link__gv7SY"};